import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/auth-module/new-rl-logo.svg'
import _imports_1 from '@/assets/auth-module/numerate-logo.svg'
import _imports_2 from '@/assets/auth-module/lingo-logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-43d24def"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center bg-gray-900/40"
}
const _hoisted_2 = { class: "bg-white flex gap-6 h-screen grid grid-cols-1 lg:grid-cols-2" }
const _hoisted_3 = { class: "h-full flex flex-col" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"pt-8 px-8 flex flex-wrap items-center gap-6\" data-v-43d24def><img class=\"w-60\" src=\"" + _imports_0 + "\" alt=\"Reflective logo\" data-v-43d24def><div class=\"w-px h-8 bg-gray-300\" data-v-43d24def></div><img class=\"h-12\" src=\"" + _imports_1 + "\" alt=\"Numerate logo\" data-v-43d24def><img class=\"h-12\" src=\"" + _imports_2 + "\" alt=\"Lingo logo\" data-v-43d24def></div>", 1)
const _hoisted_5 = { class: "mt-10 md:mt-0 flex flex-1 flex-col items-center justify-center" }
const _hoisted_6 = { class: "font-semibold text-3xl text-gray-900" }
const _hoisted_7 = { class: "font-normal text-base mt-2 mb-5" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "w-full max-w-md"
}
const _hoisted_11 = {
  key: 0,
  class: "flex items-center justify-center gap-x-2"
}
const _hoisted_12 = {
  key: 1,
  class: "font-medium text-base"
}
const _hoisted_13 = { class: "flex justify-center mt-6" }
const _hoisted_14 = { class: "text-sm text-gray-600 font-normal" }
const _hoisted_15 = {
  key: 1,
  class: "max-w-md w-full bg-gray-50 p-4 rounded-md mt-5"
}
const _hoisted_16 = { class: "text-red-600 mb-2" }
const _hoisted_17 = { class: "text-sm mb-4" }
const _hoisted_18 = {
  key: 0,
  class: "flex items-center justify-center gap-x-2"
}
const _hoisted_19 = {
  key: 1,
  class: "font-medium text-base"
}
const _hoisted_20 = {
  key: 2,
  class: "w-full max-w-md text-center px-8"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-600" }, "Please login with your registered email.", -1))
const _hoisted_22 = { class: "mt-2 text-red-600 italic" }
const _hoisted_23 = ["src"]

import { ref, onMounted, onBeforeMount } from "vue";
import router from "@/router";
import i18n from "@/plugins/i18n";
import { useUserStore } from "@/stores/userStore";
import { useRoute } from "vue-router";
import { auth } from "@/utils/firebase";
import backgroundSvg from "@/assets/auth-module/right-side-bg.svg";
import { showToast } from "@/utils/toastUtils";


export default /*#__PURE__*/_defineComponent({
  __name: 'CompleteAccountView',
  setup(__props) {

const backgroundImageStyle = `background-image: url('${backgroundSvg}')`;

//initiating user store
const userStore = useUserStore();

//route
const route = useRoute();

//Reactive variables
const email = ref("");
const password = ref("");
const confirmPassword = ref("");
const token = ref<any>("");
const tokenError = ref(false);
const adminAccountFound = ref(false);
const title = ref("");
const accountActive = ref(false);
const isLoading = ref(false);

// For the "resend link" form:
const resendEmail = ref<string>("");

onBeforeMount(() => {
  token.value = route.query.registrationToken;
});

onMounted(async () => {
  isLoading.value = true;
  if (token.value) {
    try {
      //get admin account
      const response = await userStore.getAdminAccount(token.value);

      // if admin already active
      if (response && response.status && response.status !== "inactive") {
        showToast({
          text: "Account already active, please login.",
          type: "error",
        });
        accountActive.value = true;
      }

      //set email value
      if (response && response.email) {
        email.value = response.email;
        adminAccountFound.value = true;
      }
    } catch (error) {
      tokenError.value = true;
    }
  }  
  isLoading.value = false;  
});

const handleSubmit = async (value: any) => {
  if (adminAccountFound.value) {
    const userDetails = {
      token: token.value,
      userPassword: value.password,
      courtesyTitle: value.title,
    };

    const response = await userStore.completeRegistration(userDetails);

    if (response) {
      router.push("/auth/login");
    }
  }
};

 async function handleSelfResend() {
  try {
    const result = await userStore.selfRefreshRegistrationToken({
      oldToken: token.value,
      email: resendEmail.value,
    });

    if (result.success) {
      showToast({
        text: i18n.global.t('complete_registration_view.refresh_link_success'),
        type: "success",
      });
    } else {
      showToast({
        text: i18n.global.t('complete_registration_view.refresh_link_failure'),
        type: "error",
      });
    }
  } catch (error: any) {
    console.error("Error resending link:", error);
    showToast({
      text: i18n.global.t('complete_registration_view.refresh_link_error'),
      type: "error",
    });
  }
}

const GoToLogin = () => {
  router.push("/auth/login");
};

return (_ctx: any,_cache: any) => {
  const _component_spinner_loader = _resolveComponent("spinner-loader")!
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("section", {
        class: _normalizeClass(["h-full md:overflow-y-auto", { 'opacity-50 pointer-events-none': isLoading.value }])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t("complete_registration_view.title")), 1),
            _createElementVNode("h5", _hoisted_7, [
              (!accountActive.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t("complete_registration_view.sub_title")), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_9, " Your account has already been activated. "))
            ]),
            (!tokenError.value && !accountActive.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_FormKit, {
                    type: "form",
                    id: "login-form",
                    actions: false,
                    onSubmit: handleSubmit
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_FormKit, {
                        name: "email",
                        type: "email",
                        label: _ctx.$t('complete_registration_view.email_label'),
                        validation: "required|email",
                        "outer-class": "my-2 ",
                        "input-class": "h-11 mt-1",
                        modelValue: email.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                        placeholder: _ctx.$t('complete_registration_view.email_placeholder'),
                        "validation-messages": {
                  required: _ctx.$t('complete_registration_view.email_required'),
                  length: _ctx.$t('complete_registration_view.email_length'),
                }
                      }, null, 8, ["label", "modelValue", "placeholder", "validation-messages"]),
                      _createVNode(_component_FormKit, {
                        name: "title",
                        type: "select",
                        label: _ctx.$t('complete_registration_view.courtesy_title'),
                        modelValue: title.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((title).value = $event)),
                        "outer-class": "my-2",
                        "input-class": "mt-1 border-1",
                        validation: "required",
                        "validation-messages": {
                  required: _ctx.$t('complete_registration_view.title_validation'),
                },
                        placeholder: _ctx.$t('complete_registration_view.select'),
                        options: [
                  { label: 'Mr', value: 'Mr' },
                  { label: 'Mrs', value: 'Mrs' },
                  { label: 'Miss', value: 'Miss' },
                  { label: 'Ms', value: 'Ms' },
                  { label: 'Dr', value: 'Dr' },
                ]
                      }, null, 8, ["label", "modelValue", "validation-messages", "placeholder"]),
                      _createVNode(_component_FormKit, {
                        name: "password",
                        label: _ctx.$t('complete_registration_view.password_label'),
                        type: "password",
                        validation: "required|length:6",
                        "outer-class": "mt-2",
                        "input-class": "h-11 pr-[3%] mt-1",
                        modelValue: password.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event)),
                        placeholder: 
                  _ctx.$t('complete_registration_view.password_placeholder')
                ,
                        "validation-visibility": "dirty",
                        "validation-messages": {
                  required: _ctx.$t('complete_registration_view.password_required'),
                  length: _ctx.$t('complete_registration_view.password_length'),
                }
                      }, null, 8, ["label", "modelValue", "placeholder", "validation-messages"]),
                      _createVNode(_component_FormKit, {
                        name: "password_confirm",
                        type: "password",
                        validation: "required|confirm",
                        label: _ctx.$t('complete_registration_view.confirm_password_label'),
                        "outer-class": "mt-2",
                        "input-class": "h-11 pr-[3%] mt-1",
                        modelValue: confirmPassword.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((confirmPassword).value = $event)),
                        placeholder: 
                  _ctx.$t('complete_registration_view.confirm_password_placeholder')
                ,
                        "validation-visibility": "dirty",
                        "validation-messages": {
                  required: _ctx.$t(
                    'complete_registration_view.confirm_password_required'
                  ),
                  confirm: _ctx.$t(
                    'complete_registration_view.confirm_password_confirm'
                  )
                }
                      }, null, 8, ["label", "modelValue", "placeholder", "validation-messages"]),
                      _createVNode(_component_FormKit, {
                        type: "submit",
                        class: "mb-1 mt-8 inline-block w-full bg-indigo-400 shadow-[0px 4px 10px 0px] shadow-md text-base font-medium leading-normal text-white",
                        inputClass: "mt-6 px-6 py-[10px]",
                        "validation-messages": {
                  required: _ctx.$t(
                    'complete_registration_view.button_required_message'
                  ),
                }
                      }, {
                        default: _withCtx(() => [
                          (_unref(userStore).loader.registration)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' }),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t("complete_registration_view.btn_complete")), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t("complete_registration_view.btn_get_started")), 1))
                        ]),
                        _: 1
                      }, 8, ["validation-messages"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, [
                      _createTextVNode(_toDisplayString(_ctx.$t("complete_registration_view.already_have_account")) + " ", 1),
                      _createElementVNode("a", {
                        onClick: GoToLogin,
                        class: "text-sm cursor-pointer font-semibold text-blue-600"
                      }, _toDisplayString(_ctx.$t("complete_registration_view.login")), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (tokenError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("complete_registration_view.refresh_link_title")), 1),
                  _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("complete_registration_view.refresh_link_subtitle")), 1),
                  _createVNode(_component_FormKit, {
                    type: "form",
                    actions: false,
                    onSubmit: handleSelfResend
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_FormKit, {
                        name: "resendEmail",
                        type: "email",
                        validation: "required|email",
                        label: _ctx.$t('complete_registration_view.email_label'),
                        "outer-class": "my-2 ",
                        "input-class": "h-11 mt-1 border-1",
                        modelValue: resendEmail.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((resendEmail).value = $event)),
                        placeholder: _ctx.$t('complete_registration_view.email_placeholder'),
                        "validation-messages": {
                  required: _ctx.$t('complete_registration_view.email_required'),
                  length: _ctx.$t('complete_registration_view.email_length'),
                }
                      }, null, 8, ["label", "modelValue", "placeholder", "validation-messages"]),
                      _createVNode(_component_FormKit, {
                        type: "submit",
                        class: "mb-1 mt-9 inline-block w-full bg-indigo-400 shadow-[0px 4px 10px 0px] shadow-md text-base font-medium leading-normal text-white mt-8",
                        inputClass: "mt-6 px-6 py-[10px]",
                        "validation-messages": {
                  required: _ctx.$t(
                    'complete_registration_view.button_required_message'
                  ),
                }
                      }, {
                        default: _withCtx(() => [
                          (_unref(userStore).loader.refreshSignupLink)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' }),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t("complete_registration_view.btn_loading_refresh_link")), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t("complete_registration_view.btn_refresh_link")), 1))
                        ]),
                        _: 1
                      }, 8, ["validation-messages"])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (accountActive.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("p", _hoisted_22, _toDisplayString(email.value), 1),
                  _createElementVNode("button", {
                    onClick: GoToLogin,
                    class: "formkit-input inline-block w-4/5 rounded-lg bg-blue-600 py-2 px-8 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] text-base font-semibold leading-normal text-white cursor-pointer mt-6"
                  }, _toDisplayString(_ctx.$t("complete_registration_view.login")), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 2),
      _createElementVNode("section", {
        class: "flex items-end rounded-tl-[80px] rounded-bl-[80px] bg-no-repeat bg-cover bg-center",
        style: backgroundImageStyle
      }, [
        _createElementVNode("img", {
          src: require('@/assets/auth-module/man-image.png'),
          class: "w-full",
          alt: "Man Image"
        }, null, 8, _hoisted_23)
      ])
    ])
  ], 64))
}
}

})